import React, {
  useMemo, useState,
} from 'react';

import {
  Stack,
} from '@mui/material';

import Chip from '../../../../components/Chip';
import ContentCard from '../../../../components/ContentCard';
import { Lesson } from '../../../../services/classes/types';
import ClassLessonCard from '../../ClassLessonCard';

interface LessonsCardProps {
  lessons?: Lesson[];
  selectedLesson?: Lesson;
  onSelectLesson: (lesson: Lesson) => void;
}

const LessonsCard = ({ lessons,
  selectedLesson,
  onSelectLesson }: LessonsCardProps) => {
  const [hideMarkedLessons, setHideMarkedLessons] = useState(false);

  const filteredLessons = useMemo(() => lessons?.filter(
    (lesson) => hideMarkedLessons || !lesson.rollMarked,
  ), [lessons, hideMarkedLessons]);

  return (
    <ContentCard
      variant="outlined"
      title="Lessons"
    >
      <Chip
        label="Upcoming Only"
        onClick={() => setHideMarkedLessons((prev) => !prev)}
        variant={hideMarkedLessons ? 'outlined' : 'filled'}
        color="gray"
        cursorType="pointer"
      />
      <Stack direction="column" spacing={1} marginTop={2}>
        {
          filteredLessons?.map((lesson) => (
            <ClassLessonCard
              key={lesson.id}
              lesson={lesson}
              selected={lesson.id === selectedLesson?.id}
              onSelect={() => onSelectLesson(lesson)}
              // If this is the first unmarked lesson, show new count
              showNewCount={lesson.id === filteredLessons[0].id && !lesson.rollMarked}
            />
          ))
        }
      </Stack>
    </ContentCard>
  );
};
export default LessonsCard;
